const mediaItems = [
  {
    title: '《斗破苍穹》动画PV首发',
    desc: '萧炎三年之约震撼来袭，斗气化翼特效全面升级，2026最受期待国漫动画新篇章。',
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20anime%20key%20visual%20with%20a%20young%20warrior%20in%20flowing%20robes%20surrounded%20by%20flames%20and%20energy%20effects%2C%20Chinese%20martial%20arts%20fantasy%20style%2C%20warm%20orange%20and%20golden%20tones%2C%20clean%20composition%2C%20no%20text%2C%20cinematic%20lighting&width=800&height=500&seq=media-card-01&orientation=landscape',
    tag: '动画PV',
  },
  {
    title: '国漫崛起·年度盘点特辑',
    desc: '回顾年度十大现象级国产漫画，从剧情到画风全面解析国漫的崛起之路与未来趋势。',
    img: 'https://readdy.ai/api/search-image?query=A%20colorful%20collage%20style%20illustration%20showing%20various%20Chinese%20comic%20art%20styles%20blended%20together%2C%20vibrant%20warm%20colors%2C%20modern%20digital%20art%20aesthetic%2C%20clean%20background%2C%20no%20text%2C%20editorial%20composition&width=800&height=500&seq=media-card-02&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '漫画家访谈：创作背后的故事',
    desc: '对话热门漫画《镇魂街》作者，揭秘长篇连载的创作心路与角色设计背后的灵感来源。',
    img: 'https://readdy.ai/api/search-image?query=An%20artistic%20illustration%20of%20a%20comic%20artist%20workspace%20with%20drawing%20tablet%20and%20sketches%2C%20warm%20ambient%20lighting%2C%20creative%20studio%20atmosphere%2C%20manga%20style%20sketches%20on%20desk%2C%20no%20text%2C%20cozy%20vibe&width=800&height=500&seq=media-card-03&orientation=landscape',
    tag: '访谈',
  },
  {
    title: '新手向：如何选择第一部漫画',
    desc: '从零开始的漫画阅读指南，按题材和口碑为你推荐最适合新读者的免费漫画入坑作品。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20an%20open%20comic%20book%20with%20colorful%20pages%20spread%20out%2C%20reading%20glasses%20nearby%2C%20soft%20natural%20light%2C%20cozy%20reading%20nook%20vibe%2C%20no%20text%2C%20minimalist%20composition&width=800&height=500&seq=media-card-04&orientation=landscape',
    tag: '指南',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          精彩视频
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          漫画相关的精彩视频与深度内容推荐
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer transition-colors hover:bg-background-200/70"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  title={item.title}
                  className="w-full aspect-[16/10] object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-background-50 transition-colors">
                    <i className="ri-play-fill text-xl text-accent-500 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}